/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Export_Presets_None_TextInputs */

const en_video_export_export_presets_none_text = /** @type {(inputs: Video_Export_Export_Presets_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have not saved any video export presets yet.`)
};

const fr_video_export_export_presets_none_text = /** @type {(inputs: Video_Export_Export_Presets_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous n'avez encore enregistre aucun prereglage d'exportation video.`)
};

const de_video_export_export_presets_none_text = /** @type {(inputs: Video_Export_Export_Presets_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie haben noch keine Videoexportvoreinstellungen gespeichert.`)
};

const it_video_export_export_presets_none_text = /** @type {(inputs: Video_Export_Export_Presets_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non hai ancora salvato alcun preset di esportazione video.`)
};

const ru_video_export_export_presets_none_text = /** @type {(inputs: Video_Export_Export_Presets_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы еще не сохранили ни одного параметра экспорта видео.`)
};

const es_video_export_export_presets_none_text = /** @type {(inputs: Video_Export_Export_Presets_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no has guardado ningún ajuste preestablecido de exportación de vídeo.`)
};

const zh_cn2_video_export_export_presets_none_text = /** @type {(inputs: Video_Export_Export_Presets_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您尚未保存任何视频导出预设。`)
};

const ja_video_export_export_presets_none_text = /** @type {(inputs: Video_Export_Export_Presets_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオエクスポートプリセットはまだ保存されていません。`)
};

const hi_video_export_export_presets_none_text = /** @type {(inputs: Video_Export_Export_Presets_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपने अभी तक कोई वीडियो एक्सपोर्ट प्रीसेट सेव नहीं किया है।`)
};

const pt_pt2_video_export_export_presets_none_text = /** @type {(inputs: Video_Export_Export_Presets_None_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você ainda não salvou nenhuma predefinição de exportação de vídeo.`)
};

/**
* | output |
* | --- |
* | "You have not saved any video export presets yet." |
*
* @param {Video_Export_Export_Presets_None_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_export_presets_none_text = /** @type {((inputs?: Video_Export_Export_Presets_None_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Export_Presets_None_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_export_presets_none_text(inputs)
	if (locale === "de") return de_video_export_export_presets_none_text(inputs)
	if (locale === "it") return it_video_export_export_presets_none_text(inputs)
	if (locale === "ru") return ru_video_export_export_presets_none_text(inputs)
	if (locale === "es") return es_video_export_export_presets_none_text(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_export_presets_none_text(inputs)
	if (locale === "ja") return ja_video_export_export_presets_none_text(inputs)
	if (locale === "hi") return hi_video_export_export_presets_none_text(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_export_presets_none_text(inputs)
	return en_video_export_export_presets_none_text(inputs)
});